import React from "react";

import { PRIMARY } from "../../../../Constants/colorsPalette";

type props = { inViewport: boolean; forwardedRef: any };

export default function SlideThirteen({ inViewport, forwardedRef }: props) {
  return (
    <div className="slide centered column" ref={forwardedRef}>
      <span className="slide-title">Orbit Reviews</span>
      <hr style={{ width: "80%", backgroundColor: `${PRIMARY}` }} />
      <br />
      <div className="slide-body column">
        <span className="main-description column">XXX</span>
        <span style={{ fontSize: "100px" }}>🔎</span>
        <span className="sub-description">XXX</span>
        <br />
      </div>
    </div>
  );
}
